import { Home as HomeIcon } from "@mui/icons-material";
import ValmikiImg from "../../assets/valmiki.png";
import { ReactComponent as  ChadhavaIconImg } from "../../assets/Chadhava_1.svg";
import {ReactComponent as PujaIconImg}  from "../../assets/pujaFooter.svg";
import {ReactComponent as PrasadIconImg}  from "../../assets/prasad-nav-mob.svg";
import "./Footer.scss";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { LOCALIZATION } from "../../utils/localization";
import { useTranslation } from "react-i18next";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import templeLogo from "../../assets/temple-logo-icon.png";
import packageJson from "../../../package.json";
import ImageViewer from "../imageviewer/ImageViewer";
function Footer(props: any) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const { isToShowBottomNavForMobile = false } = props;

  const navigateToAigurujiPage = (navId: string) => {
    navigate(navId);
  };
  return (
    <Box className="footerArea">
      <Box className="lgFooter" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} className="lgFtrmainGrid">
          <Grid item xs={0} sm={0} md={3} className="lgLtGrid"></Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Grid container spacing={2} className="lgMainGrid">
              <Grid item xs={12} sm={4} md={4}>
                <Box className="wiget fsec1">
                  <Box className="footerLogo">
                    <Box className="logo">
                      <NavLink to="/">
                        <img src={templeLogo} alt="Footer Logo" width={24} />
                      </NavLink>
                    </Box>

                    <Box className="logoText">
                      <NavLink to="/">
                        <Typography className="logoTextTitle">
                          Temple Dekho
                        </Typography>
                      </NavLink>
                    </Box>
                  </Box>
                  {/* <p>It will take you to a new spiritual experience.</p>
                  <p>Elevate your spiritual journey with Temple Dekho.</p> */}

                  <List className="companyInfoList">
                    <ListItem className="infoListItem">
                      <ListItemAvatar className="iconSec">
                        <HomeOutlinedIcon />
                      </ListItemAvatar>
                      <ListItemText
                        className="textSec"
                        primary={t(LOCALIZATION.Footer_address)}
                      />
                    </ListItem>

                    <ListItem className="infoListItem">
                      <ListItemAvatar className="iconSec">
                        <PhoneIphoneOutlinedIcon />
                      </ListItemAvatar>
                      <ListItemText
                        className="textSec"
                        primary="+91 90733 00055"
                      />
                    </ListItem>

                    <ListItem className="infoListItem">
                      <ListItemAvatar className="iconSec">
                        <EmailOutlinedIcon />
                      </ListItemAvatar>
                      <ListItemText
                        className="textSec"
                        primary="support@templedekho.com"
                      />
                    </ListItem>
                  </List>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
                md={2}
                className="col-sm-5 col-6 lgCentGrid"
              >
                <Box className="wiget fsec2">
                  <h6>{t(LOCALIZATION.Links)}</h6>
                  <Box className="menuFooter">
                    <Link to="/">{t(LOCALIZATION.Home)}</Link>
                    <Link to="/temples">{t(LOCALIZATION.Temples)}</Link>
                    <Link to="/pujas">{t(LOCALIZATION.Pujas)}</Link>
                    <Link to="/livedarshan">{t(LOCALIZATION.Darshan)}</Link>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4} md={2}>
                <Box className="wiget fsec3">
                  <h6>{t(LOCALIZATION.About)}</h6>
                  <Box className="menuFooter">
                    <Box className="bottomMenuList2">
                      <ul>
                        <li>
                          <a href="/about">{t(LOCALIZATION.About_Us)}</a>
                        </li>
                        <li>
                          <a href="/contactus">{t(LOCALIZATION.Contact_Us)}</a>
                        </li>
                      </ul>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={0} sm={0} md={4} className="lgRtGrid">
                <Box className="wiget fsec3">
                  <h6>{t(LOCALIZATION.Information)}</h6>
                  <div className="bottomMenuList2">
                    <ul>
                      {/* <li>
              <a href="#">
                <InsertCommentIcon />
                Feedback
              </a>
            </li> */}
                      <li>
                        <a href="/refundscancellations">
                          {/* <PaymentsIcon /> */}
                          {t(LOCALIZATION.Refunds_and_Cancellations)}
                        </a>
                      </li>

                      <li>
                        <a href="/communityguidelines">
                          {/* <LocalLibraryIcon /> */}
                          {t(LOCALIZATION.Content_Community_Guidlines)}
                        </a>
                      </li>

                      <li>
                        <a href="/privacypolicy">
                          {/* <PolicyIcon /> */}
                          {t(LOCALIZATION.Privacy_Policy)}
                        </a>
                      </li>
                      <li>
                        <a href="/termsandconditions">
                          {/* <GavelIcon /> */}
                          {t(LOCALIZATION.Terms_and_Conditions)}
                        </a>
                      </li>

                      {/* <li>
              <a href="#">
                <SettingsIcon />
                Settings
              </a>
            </li> */}
                    </ul>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={0} sm={0} md={3} className="lgLtGrid"></Grid>
        </Grid>

        <Box className="copyright-text">
          <Typography sx={{ color: "#E6E6E6" }}>
            App Version : {packageJson.version}
          </Typography>
          &#169; Copyright {currentYear},{" "}
          <a href="/privacypolicy">Temple Dekho</a> All Rights Reserved.
        </Box>
      </Box>
      {isToShowBottomNavForMobile ? (
        <Box className="smFooter">
          <Grid container spacing={3} className="footerMenu">
            <Grid item xs={2} className="menuItems">
              <NavLink to="/">
                <HomeIcon />
                <span>{t(LOCALIZATION.Home)}</span>
              </NavLink>
            </Grid>
            {/* <Grid item xs={3} className="menuItems">
              <NavLink to="/search">
                <SearchIcon />
                <span>Search</span>
              </NavLink>
            </Grid> */}
            <Grid item xs={2} className="menuItems">
              <NavLink to="/chadhavaTemples">
                <ChadhavaIconImg  width={22} height={22} fill="#767676" />
                <span>{t(LOCALIZATION.Chadhava)}</span>
              </NavLink>
            </Grid>
            <Grid item xs={2} className="menuItems">
              <NavLink to="/pujas">
                <PujaIconImg  width={22} height={22} fill="#767676" />
                <span className="pujaText">{t(LOCALIZATION.Puja)}</span>
              </NavLink>
            </Grid>
            <Grid item xs={2} className="menuItems">
              <NavLink to="/prasadTemples">
                <PrasadIconImg  width={24} height={24}  fill="#767676"/>
                <span className="pujaText">{t(LOCALIZATION.Prasad)}</span>
              </NavLink>
            </Grid>
            <Grid item xs={2} className="menuItems">
              <Box
                className="footerAiguruji"
                onClick={(e) => {
                  e.preventDefault();
                  navigateToAigurujiPage("/ai-valmiki");
                }}
              >
                <img
                  src={ValmikiImg}
                  className="aiGurujiClick"
                  alt="Ai Guruji"
                />
                <span>{t(LOCALIZATION.VALMIKI)}</span>
              </Box>
            </Grid>
            {/* <Grid item xs={3} className="menuItems">
              <Box className="cartBlock">
                <NavLink to="/checkoutV2/reviewCart">
                  <Box className="smCartIcon">
                    <ShoppingCartIcon />
                    {cartInfo && cartInfo.length > 0 ? (
                      <span className="smBadge">{cartInfo.length}</span>
                    ) : null}
                  </Box>
                  <span>{t(LOCALIZATION.Cart)}</span>
                </NavLink>
              </Box>
            </Grid> */}
          </Grid>
        </Box>
      ) : null}
    </Box>
  );
}

export default Footer;
